/**
 * Use this file to use the icons across the app, it will allow to only generate the icon css for those and not the 1.7k others
 */

export enum IconNames {
  tool_01 = 'ki:tool-01',
  bank = 'ki:bank',
  tool_02 = 'ki:tool-02',
  plus = 'ki:plus',
  file_06 = 'ki:file-06',
  zap = 'ki:zap',
  minus = 'ki:minus',
  hourglass_01 = 'ki:hourglass-01',
  check = 'ki:check',
  arrows_right = 'ki:arrows-right',
  message_dots_square = 'ki:message-dots-square',
  arrows_down = 'ki:arrows-down',
  paperclip = 'ki:paperclip',
  image_user = 'ki:image-user',
  chevron_selector_horizontal = 'ki:chevron-selector-horizontal',
  chevron_selector_horizontal_inversed = 'ki:chevron-selector-horizontal-inversed',
  question_mark = 'ki:question-mark',
  link_broken_01 = 'ki:link-broken-01',
  google_chrome = 'ki:google-chrome',
  globe_04 = 'ki:globe-04',
  loading_02 = 'ki:loading-02',
  copy_02 = 'ki:copy-02',
  bell_01 = 'ki:bell-01',
  refresh_ccw_03 = 'ki:refresh-ccw-03',
  refresh_ccw_05 = 'ki:refresh-ccw-05',
  slash_circle_01 = 'ki:slash-circle-01',
  file_download_02 = 'ki:file-download-02',
  file_plus_02 = 'ki:file-plus-02',
  coins_hand = 'ki:coins-hand',
  help_circle = 'ki:help-circle',
  arrow_narrow_right = 'ki:arrow-narrow-right',
  arrow_narrow_up_right = 'ki:arrow-narrow-up-right',
  link_04 = 'ki:link-04',
  arrow_narrow_left = 'ki:arrow-narrow-left',
  download_01 = 'ki:download-01',
  rocket_01 = 'ki:rocket-01',
  search_refraction = 'ki:search-refraction',
  users_03 = 'ki:users-03',
  upload_01 = 'ki:upload-01',
  certificate_01 = 'ki:certificate-01',
  attachment_01 = 'ki:attachment-01',
  columns_03 = 'ki:columns-03',
  filter_funnel_01 = 'ki:filter-funnel-01',
  refresh_ccw_01 = 'ki:refresh-ccw-01',
  refresh_ccw_02 = 'ki:refresh-ccw-02',
  trash_01 = 'ki:trash-01',
  layout_alt_03 = 'ki:layout-alt-03',
  dots_horizontal = 'ki:dots-horizontal',
  dots_vertical = 'ki:dots-vertical',
  lock_01 = 'ki:lock-01',
  folder = 'ki:folder',
  command = 'ki:command',
  settings_02 = 'ki:settings-02',
  log_out_01 = 'ki:log-out-01',
  pie_chart_03 = 'ki:pie-chart-03',
  users = 'ki:users-01',
  flip_backward = 'ki:flip-backward',
  face_id = 'ki:face-id',
  bar_chart_square_plus = 'ki:bar-chart-square-plus',
  pencil_line = 'ki:pencil-line',
  home_line = 'ki:home-line',
  eye_off = 'ki:eye-off',
  eye = 'ki:eye',
  moon_star = 'ki:moon-star',
  star_06 = 'ki:star-06',
  sun = 'ki:sun',
  monitor_01 = 'ki:monitor-01',
  search_md = 'ki:search-md',
  arrow_up = 'ki:arrow-up',
  arrow_down = 'ki:arrow-down',
  arrow_up_right = 'ki:arrow-up-right',
  chevron_up = 'ki:chevron-up',
  chevron_right = 'ki:chevron-right',
  chevron_down = 'ki:chevron-down',
  hash_02 = 'ki:hash-02',
  menu_03 = 'ki:menu-03',
  x_close = 'ki:x-close',
  check_circle = 'ki:check-circle',
  info_circle = 'ki:info-circle',
  x_circle = 'ki:x-circle',
  alert_circle = 'ki:alert-circle',
  alert_triangle = 'ki:alert-triangle',
  check_circle_broken = 'ki:check-circle-broken',
  user_01 = 'ki:user-01',
  building_07 = 'ki:building-07',
  building_08 = 'ki:building-08',
  pen_tool_02 = 'ki:pen-tool-02',
  mail_01 = 'ki:mail-01',
}
